/* eslint-disable no-unused-vars,no-console,no-nested-ternary,max-len */
import React from 'react';
import PropTypes from 'prop-types';
import firebase from 'firebase';
import { useAuthState } from 'react-firebase-hooks/auth';
import { navigate } from '@reach/router';
import ShoppingCartContext from '../shopping-cart-context';
import ShoppingCartQuickViewContext from './shopping-cart-quick-view-context';
import EmptyBasketIcon from '../../../images/icons/empty-basket-icon.svg';
import getCartTotalQuantity from '../getCartTotalQuantity';
import './style.scss';
import getCartTotalPrice from '../getCartTotalPrice';
import getIsWholesaleAccount from '../../../utils/getIsWholesaleAccount';

const ShoppingCartQuickView = () => {
    const {
        cart = [],
        removeFromCart,
        updateCartItemQuantity,
    } = React.useContext(ShoppingCartContext);

    const { toggleCartQuickView } = React.useContext(ShoppingCartQuickViewContext);
    // eslint-disable-next-line no-unused-vars
    const [authUser, userInitialising, userError] = typeof window !== 'undefined' ? useAuthState(firebase.auth()) : Array(3);
    const [isWholesaleAccount, setIsWholesaleAccount] = React.useState(false);

    if (authUser) {
        getIsWholesaleAccount()
            .then((wholesaleResult) => {
                setIsWholesaleAccount(wholesaleResult);
            });
    }

    const priceField = isWholesaleAccount ? 'wholesale_price' : 'price';
    const cartSubTotal = parseFloat(getCartTotalPrice(cart, priceField));

    return (
        <div className="quickview shopping-cart-quickview">
            {/* <div className="shopping-cart-quickview__pattern-background" /> */}
            {/* <div className="shopping-cart-quickview__pattern-background-overlay" /> */}
            {/* <div className="shopping-cart-quickview__main-content"> */}

            {
                cart.length > 0 && (
                    <div className="checkout-action-header is-paddingless">
                        <div className="cart-subtotal is-flex">
                            <div
                                className="title is-size-6-touch is-size-5-desktop has-text-white is-uppercase is-marginless"
                            >
                                Subtotal
                            </div>
                            <div className="has-text-white is-uppercase">
                                {`£${cartSubTotal.toFixed(2)}`}
                            </div>
                        </div>
                        <div className="cart-shipping is-flex">
                            <div
                                className="title is-size-6-touch is-size-5-desktop has-text-white is-uppercase is-marginless"
                            >
                                Shipping
                            </div>
                            <div className="has-text-white is-uppercase">
                                Calculated at checkout
                            </div>
                        </div>

                        {
                            !userInitialising && !authUser && (
                                <button
                                    type="button"
                                    className="checkout-button button is-theme-info is-fullwidth"
                                    onClick={async () => {
                                        console.log('signing in anonymosly');
                                        firebase
                                            .auth().signInAnonymously()
                                            .then((user) => {
                                                console.log('shaz', user);
                                                navigate('/checkout');
                                            })
                                            .catch((error) => {
                                                console.log(error);
                                            });
                                    }}
                                >
                                    <span className="icon">
                                        <i className="fas fa-user-slash has-text-white" />
                                    </span>
                                    <span className="title is-size-6-touch is-size-5-desktop checkout-button-text">
                            Checkout as guest
                                    </span>
                                </button>
                            )
                        }

                        <button
                            type="button"
                            className="checkout-button button is-theme-success is-fullwidth"
                            onClick={() => {
                                navigate(authUser ? '/checkout' : '/login');
                            }}
                        >
                            <span className="icon">
                                <i className="fas fa-check has-text-white" />
                            </span>
                            <span className="title is-size-6-touch is-size-5-desktop checkout-button-text">
                            Checkout
                            </span>
                        </button>

                    </div>
                )
            }

            <header className="quickview-header">
                <div>
                    <div
                        className="title is-size-3-touch is-size-4-desktop"
                    >
                        {`${getCartTotalQuantity(cart)} cart items`}
                    </div>
                    <div className="subtitle is-size-6-touch is-size-5-desktop">
                        Below are the products you have added to your cart
                    </div>
                </div>
            </header>

            <div className="quickview-body">
                <div className="quickview-block">
                    {cart.length === 0 && (
                        <div className="cart-empty-container">
                            <img src={EmptyBasketIcon} alt="Empty basket" />
                            <div className="title is-size-3-desktop">Your cart is empty!</div>
                            <div
                                className="button is-success is-large"
                                onClick={() => {
                                    console.log('toggleCartQuickView');
                                    toggleCartQuickView();
                                }}
                            >
                                <strong>
                                    Continue Shopping
                                </strong>
                            </div>
                        </div>
                    )}
                    {
                        cart.map(cartItem => (
                            <div
                                className="shopping-cart-quickview__cart-item card is-vertical-center is-flex"
                            >

                                <span
                                    className="cart-remove-icon icon"
                                    onClick={() => {
                                        removeFromCart(cartItem.product);
                                    }}
                                >
                                    <i className="fas fa-trash-alt" />
                                </span>
                                <img
                                    src={cartItem.product.variant.images[0].url}
                                    alt={cartItem.product.name}
                                />

                                <div className="shopping-cart-quickview__cart-item__info_text">
                                    <div
                                        className="title is-size-6-touch is-size-5-desktop"
                                    >
                                        {cartItem.product.variant.name}
                                    </div>
                                    <div
                                        className="subtitle is-size-6-touch is-size-5-desktop "
                                    >
                                        {cartItem.product.name}
                                    </div>
                                    <QuantityDropdown
                                        variantId={cartItem.product.variant.id}
                                        selectedQuantity={cartItem.quantity}
                                        maxQuantity={20}
                                        onSelect={
                                            newQuantity => updateCartItemQuantity(
                                                cartItem.product,
                                                newQuantity,
                                            )
                                        }
                                    />
                                    <div
                                        className="shopping-cart-quickview__cart-item__price title is-size-5-touch is-size-5-desktop has-text-left is-hidden-desktop"
                                    >
                                        {`£${getCartTotalPrice([cartItem], priceField)}`}
                                    </div>
                                </div>
                                <div
                                    className="shopping-cart-quickview__cart-item__price title is-size-5-touch is-size-5-desktop is-hidden-touch"
                                >
                                    {`£${getCartTotalPrice([cartItem], priceField)}`}
                                </div>

                            </div>
                        ))
                    }
                </div>
            </div>
            {/* </div> */}
        </div>
    );
};

ShoppingCartQuickView.propTypes = {};

export default ShoppingCartQuickView;

const QuantityDropdown = ({
    variantId, selectedQuantity, minQuantity, maxQuantity, onSelect,
}) => (
    <div className={`cart-item-quantity-dropdown-${variantId} dropdown`}>
        <div className="dropdown-trigger">
            <button
                className="button "
                aria-haspopup="true"
                aria-controls="dropdown-menu2"
                type="button"
                onClick={() => {
                    // eslint-disable-next-line no-undef
                    const dropdown = document.querySelector(`.cart-item-quantity-dropdown-${variantId}`);
                    dropdown.classList.toggle('is-active');
                }}
            >
                <span className="is-size-6-touch is-size-5-desktop">{`QTY: ${selectedQuantity}`}</span>
                <span className="icon is-small">
                    <i className="fas fa-angle-down" aria-hidden="true" />
                </span>
            </button>
        </div>
        <div
            className="full-page-overlay"
            onClick={() => {
                // eslint-disable-next-line no-undef
                const dropdown = document.querySelector(`.cart-item-quantity-dropdown-${variantId}`);
                dropdown.classList.remove('is-active');
            }}
        />
        <div className="dropdown-menu" id="dropdown-menu2" role="menu">
            <div className="dropdown-content">
                {
                    Array(maxQuantity - minQuantity + 1)
                        .fill()
                        .map((_, idx) => minQuantity + idx)
                        .map(q => (
                            <div
                                className="dropdown-item is-size-6-touch is-size-5-desktop"
                                onClick={() => {
                                    onSelect(q);
                                    // eslint-disable-next-line no-undef
                                    const dropdown = document.querySelector(`.cart-item-quantity-dropdown-${variantId}`);
                                    dropdown.classList.toggle('is-active');
                                }}
                            >
                                {q}
                            </div>
                        ))
                }
            </div>
        </div>
    </div>
);

QuantityDropdown.defaultProps = {
    minQuantity: 1,
};

QuantityDropdown.propTypes = {
    variantId: PropTypes.number.isRequired,
    selectedQuantity: PropTypes.number.isRequired,
    minQuantity: PropTypes.number,
    maxQuantity: PropTypes.number.isRequired,
    onSelect: PropTypes.func.isRequired,
};
